import React from "react";
import classnames from "classnames";
import Isvg from "../../../../vendor/react-inlinesvg";
import OverleafAction from "../../../actions/overleaf-action";
import OverleafStore, { TYPE_IMAGE } from "../../../stores/overleaf-store";
import Swipeable from "react-swipeable";
import FigureOrImage from "./figure-or-image";
import { VisibleLineBreaks } from "../../../ui/components/mixins";

class Flashcard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flipped: false,
      cardContent: props.front,
      side: "front"
    };
    this.flip = this.flip.bind(this);
    this.clickCard = this.clickCard.bind(this);
    this.swipedLeft = this.swipedLeft.bind(this);
    this.swipedRight = this.swipedRight.bind(this);
    this.swiping = this.swiping.bind(this);
    this.focusOnCard = this.focusOnCard.bind(this);
    this.studyWeak = this.studyWeak.bind(this);
    this.studyAll = this.studyAll.bind(this);
  }

  focusOnCard() {
    this.props.focusCardHolder();
    this.mainCard.element.focus();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.inView !== this.props.inView) {
      this.setState({ swipingLeft: false, swipingRight: false });
      if (this.state.flipped && !nextProps.inView) {
        setTimeout(this.flip(), 500);
      }
      if (nextProps.inView && (this.props.isLeft || this.props.isRight)) {
        setTimeout(() => {
          this.focusOnCard();
        }, 500);
      }
    }
  }

  flip(e) {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    this.setState(prevState => ({ flipped: !prevState.flipped }));
    setTimeout(() => {
      this.setState(
        {
          cardContent: this.state.flipped ? this.props.back : this.props.front,
          side: this.state.flipped ? "back" : "front"
        },
        this.focusOnCard
      );
    }, 250);
    Fraction.Reporter.noticeInteraction("flashcards-card-interaction", {
      cardId: this.props.uuid,
      type: "flip"
    });
  }

  clickCard(e) {
    e.stopPropagation();
    if (this.props.inView) {
      this.flip(e);
    } else if (this.props.immediateLeft) {
      this.props.previousCard();
    } else if (this.props.immediateRight) {
      this.props.nextCard();
    }
  }

  rateCard(confidence) {
    OverleafAction.setConfidence(this.props, confidence);
    Fraction.Reporter.noticeInteraction("flashcards-card-interaction", {
      cardId: this.props.uuid,
      type:
        confidence === OverleafStore.CONFIDENCE.CONFIDENT
          ? "I know it"
          : "I don't know it"
    });
  }

  renderConfidenceIcon(confidence, color) {
    let confidenceLevel = confidence === this.props.confidence;
    let svg = `img/face_${color}.svg`;
    let btnTxt =
      color === "red"
        ? i18n.t("flashcards.dont-know")
        : i18n.t("flashcards.know-it");
    const classes = classnames("rating", color, { active: confidenceLevel });
    return (
      <button
        onClick={() => {
          this.rateCard(confidence);
        }}
        className={classes}
        aria-pressed={confidenceLevel}
      >
        <Isvg key={`face-${svg}`} src={svg} />
        <span className="rating-text">{btnTxt}</span>
      </button>
    );
  }

  renderRatings() {
    return (
      <div className="card-rating">
        {this.renderConfidenceIcon(
          OverleafStore.CONFIDENCE.NOT_CONFIDENT,
          "red"
        )}
        {this.renderConfidenceIcon(OverleafStore.CONFIDENCE.CONFIDENT, "green")}
      </div>
    );
  }

  swiping(e, deltaX, deltaY, absX, absY, velocity) {
    if (deltaX > 25 && !this.state.swipingLeft) {
      this.setState({ swipingLeft: true });
    } else if (deltaX < 25 && this.state.swipingLeft) {
      this.setState({ swipingLeft: false });
    }
    if (deltaX < -25 && !this.state.swipingRight) {
      this.setState({ swipingRight: true });
    } else if (deltaX > -25 && this.state.swipingRight) {
      this.setState({ swipingRight: false });
    }
  }

  swipedLeft(e, deltaX, isFlick) {
    if (isFlick) {
      this.props.nextCard();
    } else {
      this.setState({ swipingLeft: false, swipingRight: false });
    }
  }

  swipedRight(e, deltaX, isFlick) {
    if (this.props.canSwipeRight && isFlick) {
      this.props.previousCard();
    } else {
      this.setState({ swipingLeft: false, swipingRight: false });
    }
  }

  studyWeak() {
    this.props.studyWeak(OverleafStore.CONFIDENCE.NOT_CONFIDENT);
    this.props.hideIntroCard(null, true, null);
    Fraction.Reporter.noticeInteraction("flashcards-study", {
      type: "weak cards",
      deckId: this.props.deckId
    });
  }

  studyAll() {
    this.props.startOver();
    this.props.hideIntroCard(null, null, true);
    Fraction.Reporter.noticeInteraction("flashcards-study", {
      type: "all cards",
      deckId: this.props.deckId
    });
  }

  render() {
    const classes = classnames("flashcard", this.state.side, {
      flipped: this.state.flipped,
      visible: this.props.inView,
      isLeft: this.props.isLeft,
      immediateLeft: this.props.immediateLeft,
      isRight: this.props.isRight,
      immediateRight: this.props.immediateRight,
      swipingLeft: this.props.inView && this.state.swipingLeft,
      swipingRight: this.props.inView && this.state.swipingRight
    });
    if (this.props.loading) {
      return (
        <div className={classes}>
          <div className="card-content">
            <span className="hintText">{i18n.t("base.loading")}</span>
            <Isvg src="/img/loader_lg.svg" />
          </div>
        </div>
      );
    }
    if (this.props.introCard) {
      let notConfident = this.props.stats.notConfident;
      let allCards = this.props.allCards;
      return (
        <div className={classes}>
          <div id="intro-card" className="card-content">
            <button className="noButton" onClick={this.studyWeak}>
              <Isvg className="intro-svg" src="/img/card-icon-face-sad.svg" />
              {i18n.t("flashcards.study-weak-cards-intro", {
                number: notConfident
              })}
            </button>
            <button className="noButton" onClick={this.studyAll}>
              <Isvg className="intro-svg" src="/img/card-icon-all-cards.svg" />
              {i18n.t("flashcards.study-all-cards", { number: allCards })}
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className={classes}>
        <Swipeable
          ref={cd => {
            this.mainCard = cd;
          }}
          tabIndex={this.props.inView ? 0 : -1}
          stopPropagation={true}
          preventDefaultTouchmoveEvent={true}
          onSwiping={this.swiping}
          onSwipedLeft={this.swipedLeft}
          onSwipedRight={this.swipedRight}
          className="card-content"
          onClick={this.clickCard}
        >
          <span className="hintText">{this.props.progressHint}</span>
          <span className="hintText">
            {this.state.flipped
              ? i18n.t("flashcards.back-of-card")
              : i18n.t("flashcards.front-of-card")}
          </span>
          <button className="flip-arrow" onClick={this.flip}>
            <span className="hintText">{i18n.t("flashcards.flip-card")}</span>
            <Isvg src="/img/arrow-curved-left.svg" />
          </button>
          <span className="flashcard-text">
            {this.state.cardContent.type === TYPE_IMAGE ? (
              <FigureOrImage
                src={this.state.cardContent.content}
                title={this.state.cardContent.metadata.title}
                caption={this.state.cardContent.metadata.caption}
                alt={this.state.cardContent.metadata.alt}
              />
            ) : (
              <VisibleLineBreaks>
                {this.state.cardContent.content}
              </VisibleLineBreaks>
            )}
          </span>
        </Swipeable>
        {this.renderRatings()}
        {Fraction.Helpers.isSmallScreen() && (
          <span className="hintText">{i18n.t("flashcards.tap-to-flip")}</span>
        )}
      </div>
    );
  }
}

export default Flashcard;
